





































import {Component, Vue} from "vue-property-decorator";
import {Project, ProjectService} from "@/services/project.service";
import ProgrammingLanguages from "@/components/ui/programmingLanguages.vue";
import Hagame3d from "@/views/HaGame3D.vue";

@Component({components: {ProgrammingLanguages, Hagame3d}})
export default class Projects extends Vue {
    private initialized = false;
    private projects!: Project[];
    private projectService!: ProjectService;
    private playerWidth = 0;
    private playerHeight = 0;

    private async mounted() {
        this.playerWidth = Math.min((this.$refs["container"] as any).clientWidth - 0.20 * document.body.clientWidth, 620);
        this.playerHeight = this.playerWidth * 0.75;
        this.projectService = new ProjectService();
        const res = await this.projectService.get();
        if (res.success) this.projects = res.result;
        this.initialized = true;
    }
}
